module.exports = __webpack_public_path__ + "static/21-7841d633bdc78f2c717ec6a3f31c17c9.gif";